//export const API_BASE_URL = "http://127.0.0.1:8000";
export const API_BASE_URL = "https://oildcr.bgoil.in/admin";
